<template>
  <div class="box table-scroll">
    <b-table :data="rows" narrowed hoverable fullwidth>

      <b-table-column v-if="$store.getters.hasAnyRole(['lyris'])" field="orgName" label="Org" centered v-slot="props">
        {{ props.row.orgName }}
      </b-table-column>

      <b-table-column v-for="col in columns" :key="col.field" :field="col.field" :label="col.label" centered
        v-slot="props">
        <div class="cell-wrapper" :class="cellClass(props.row, col)" @click="onCellClick(props.row, col)">
          {{ props.row[col.field] }}
        </div>
      </b-table-column>

      <template #empty>
        <div class="has-text-centered has-text-grey">
          No data available
        </div>
      </template>

    </b-table>
  </div>
</template>

<script>
export default {
  name: 'CertsTable',

  props: {
    rows: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      columns: [
        { field: 'total', label: 'Total' },
        { field: 'prePendiente', label: 'Pre-Pendiente' },
        { field: 'pendiente', label: 'Pendiente' },
        { field: 'rechazado', label: 'Rechazado' },
        { field: 'vencido', label: 'Vencido' },
        { field: 'revocado', label: 'Revocado' },
        { field: 'preaprobado', label: 'Pre-Aprobado' },
        { field: 'vigente', label: 'Vigente' },
        { field: 'proximosAVencer', label: 'Próximos a Vencer' }
      ]
    }
  },

  methods: {
    cellClass (row, col) {
      const value = row[col.field] ?? 0

      if (col.field === 'total') {
        return {
          'cell-disabled': true,
          'has-text-grey': true
        }
      }

      if (Number(value) === 0) {
        return {
          'cell-disabled': true,
          'has-text-grey-light': true
        }
      }

      return {
        'cell-clickable': true,
        'is-clickable': true,
        'has-text-link': true
      }
    },

    onCellClick (row, col) {
      if (col.field === 'total') return

      if (col.field === 'proximosAVencer') {
        this.$emit('request-certificados', {
          orgId: row.orgId,
          estado: 'proxAVencer'
        })
        return
      }

      if (row[col.field] === 0) return

      this.$emit('request-certificados', {
        orgId: row.orgId,
        estado: col.field
      })
    }
  }
}
</script>

<style scoped>
.table-scroll {
  max-height: 60vh;
  overflow-y: auto;
}

::v-deep .table {
  border-collapse: separate !important;
  border-spacing: 0;
}

::v-deep .table thead th {
  position: sticky;
  top: 0;

  background-color: white;
  color: black;

  z-index: 20;

  background-clip: padding-box;

  /* box-shadow: inset 0 -2px 0 #4a4a4a; */
}

::v-deep .table tbody td {
  position: relative;
  z-index: 1;
}

.cell-wrapper {
  width: 100%;
  height: 100%;
  padding: 0.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  transition: background-color 0.15s ease;
}

.cell-clickable:hover {
  background-color: #555657;
}

.cell-clickable:active {
  background-color: #3f4041;
}

.cell-disabled {
  cursor: default;
}
</style>
